import React, { memo, useMemo } from 'react';

// Official TradingView Advanced Real-Time Chart embed, isolated in an iframe
// (srcdoc isolation prevents third-party script errors leaking into the app)
export const TradingViewWidget = memo(({ symbol = 'BINANCE:BTCUSDT', studies = [], height = 610 }) => {
  const srcDoc = useMemo(() => {
    const config = {
      autosize: true,
      symbol,
      interval: '60',
      timezone: 'Etc/UTC',
      theme: 'dark',
      style: '1',
      locale: 'en',
      backgroundColor: 'rgba(10, 10, 10, 1)',
      gridColor: 'rgba(255, 255, 255, 0.06)',
      hide_side_toolbar: false,
      allow_symbol_change: true,
      studies: studies.length > 0 ? studies : ['STD;EMA', 'STD;RSI'],
      details: true,
      calendar: false,
      support_host: 'https://www.tradingview.com',
    };
    return `<!DOCTYPE html><html><head><style>html,body{margin:0;padding:0;height:100%;background:#0A0A0A}</style></head>
<body>
<div class="tradingview-widget-container" style="height:100%;width:100%">
  <div class="tradingview-widget-container__widget" style="height:100%;width:100%"></div>
  <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js" async>
  ${JSON.stringify(config)}
  <\/script>
</div>
</body></html>`;
  }, [symbol, JSON.stringify(studies)]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <iframe
      title="TradingView Live Chart"
      srcDoc={srcDoc}
      style={{ height, width: '100%', border: 'none', display: 'block', background: '#0A0A0A' }}
      allow="fullscreen"
      data-testid="tradingview-widget"
    />
  );
});

export default TradingViewWidget;
